import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {

        why_to_choose_us: "Why to choose us?",
  wide_variety_of_choices: "Wide Variety of Choices",
  we_believe_food_should_cater_to_everyone: "We believe that food should cater to everyone’s tastes and dietary needs, which is why we offer a broad selection of cuisines, flavors, and meal options. Whether you're craving comfort food, seeking a healthy salad, or trying something adventurous, we’ve got you covered.",
  menu_includes_options_for_every_preference: "Our menu includes options for every preference, from vegan, vegetarian, and gluten-free choices to high-protein and low-calorie meals for health-conscious eaters. We even rotate seasonal and special items to keep things exciting and aligned with what’s fresh and in season.",
  curating_diverse_range_of_meals: "By curating a diverse range of meals and working with talented chefs, we ensure there's always something new and delicious for you to try. You can always find the perfect meal, no matter your cravings or dietary needs.",

  reliable_and_fast_delivery: "Reliable and Fast Delivery",
  delivery_service_peak_condition: "Our delivery service is built to ensure your food reaches you in peak condition. We know how important timing is when it comes to food. That's why we use advanced route optimization, ensuring that our drivers take the quickest, most efficient paths to your door.",
  real_time_tracking: "With real-time tracking, you’ll always know where your order is, so you can plan your time without any surprises. We also keep our delivery times short to guarantee that your food arrives as fresh and delicious as if it just left the kitchen.",
  experienced_delivery_drivers: "Our team of experienced delivery drivers is dedicated to excellence in service, handling every order with care so you can enjoy a consistently reliable experience every time you choose us.",

  user_friendly_technology: "User-Friendly Technology",
  smooth_and_convenient_ordering: "We’ve designed our ordering platform to make your food delivery experience as smooth and convenient as possible. Whether you’re using our app or website, you’ll find it simple and intuitive to browse the menu, customize your meal, and place an order in just a few clicks.",
  real_time_tracking_and_secure_payments: "Our real-time tracking lets you stay updated on your order’s status every step of the way, from the kitchen to your doorstep. And with multiple secure payment options, checkout is quick and hassle-free. Enjoy convenience at your fingertips, designed to fit seamlessly into your busy lifestyle.",

  affordable_pricing_and_promotions: "Affordable Pricing and Promotions",
  customers_at_heart: "Our customers are at the heart of everything we do. We’re committed to ensuring your satisfaction with every order, and our customer service team is here to support you from start to finish. Whether you need assistance with placing an order, tracking your delivery, or resolving an issue, our dedicated team is just a message.",
  listen_to_feedback: "We listen to your feedback and take it seriously, continually improving our service based on what you tell us. With a focus on quick response times and friendly, helpful service, we’re here to make sure your experience with us is consistently outstanding.",
  go_above_and_beyond: "Our team is trained to go above and beyond, handling each inquiry with care and professionalism. When you choose us, you’re choosing a service that values your experience and works to make every meal feel personal and memorable.",

  couriers: "Couriers",
  competitive_earnings: "Competitive Earnings",
  earnings_text: "At LoadInn, we believe that your hard work should translate into real financial rewards. Our rates are among the highest in the industry. With us, every delivery truly counts toward a rewarding pay check.",
  flexible_scheduling: "Flexible Scheduling",
  flexible_scheduling_text: "Flexibility is one of the top reasons people choose to be couriers, and we respect that. Whether you prefer full-time, part-time, weekends, or just a few hours each day, you’re in control of your schedule. Our app makes it simple go Online when you’re ready to work and Offline when you're done, offering the ultimate balance between work and personal time.",
  support_and_resources: "24/7 Support and Resources",
  support_and_resources_text: "We know that couriers sometimes face unexpected challenges. Our dedicated support team is available around the clock, ready to help with anything you need—from route adjustments to app support. We also provide you with training resources and up-to-date tips on safety, customer service, and efficiency so you can deliver with confidence.",
  reliable_and_transparent_payments: "Reliable and Transparent Payments",
  reliable_and_transparent_payments_text: "With LoadInn, you can trust that your hard-earned money will arrive on time, every time. Our transparent payment system shows you exactly what you’re earning for each delivery, with no hidden fees. You’ll also receive payments weekly or even faster with our instant pay option, keeping your cash flow steady and dependable.",
  local_delivery_focus: "Local Delivery Focus",
  local_delivery_focus_text: "We prioritize assignments in your area, meaning you get to work close to home and cut down on travel time and fuel costs. Familiar neighbourhoods mean quicker deliveries and smoother routes, helping you complete more jobs in less time and earn more without the hassle of long commutes.",

  restaurant: "Restaurant",
  get_started: "Get Started!",
  get_started_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  register_your_restaurant_now: "Register Your Restaurant Now!",
  need_help: "Need Help?",
  need_help_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  email_us: "Email Us",
  call_us: "Call Us"
  ,
about_us: "About Us",
  who_we_are: "Who We Are",
  question_mark: "?",
  who_we_are_alt: "Who we are image",
  we_believe_food_is_more_than_meal: "At LoadInn, we believe that food is more than just a meal—it’s a way to bring people together, create experiences, and celebrate community. Our platform is designed to bridge the gap between customers and local restaurants, providing a service that benefits both sides in meaningful ways. We’re committed to creating a seamless, affordable, and rewarding experience for everyone involved.",
  
  for_our_customers: "For Our Customers",
  customers_seek_quality_transparency: "We understand that today’s customers are looking for more than just convenience; they want quality food, transparency, and affordable prices.",
  customers_section1_img_alt: "We built our platform with you in mind",
  customers_section1_text: "At LoadInn, we’ve built our platform with you in mind. By listing a diverse range of local restaurants, we give you the opportunity to explore and order from your favourites, all in one place. We are committed to keeping prices fair.",
  customers_section2_img_alt: "Without hidden commission fees",
  customers_section2_text: "Since we don’t charge high commission fees to restaurants, they can pass those savings on to you. This means you get great food at affordable prices—without hidden charges. At LoadInn, it’s our priority to ensure that every meal you order is not only delicious but also offers great value.",
  
  for: "For",
  our_partner_restaurants: "Our Partner Restaurants",
  partner_restaurants_img_alt: "Partner restaurants image",
  restaurants_heart_of_community: "We know that restaurants are the heart of any community, and we’re here to support you in thriving without the burden of high commission rates.",
  subscription_model_advantages: "Unlike traditional food delivery platforms, LoadInn does not charge restaurants a commission on orders. Instead, we offer a straightforward subscription-based model that allows you to control your costs, increase your visibility, and serve more customers—all while keeping more of your hard-earned revenue.",
  financial_flexibility_for_restaurants: "This approach helps you grow your business sustainably and offers greater financial flexibility. We’re here to help you reach more diners, streamline operations, and continue offering the exceptional dining experiences that make your restaurant unique.",
  
  building_fairer_stronger_community: "Building a Fairer, Stronger Community",
  loadinn_more_than_platform: "LoadInn is more than just a platform; it’s a movement to make the food delivery experience better for everyone. By not charging commissions, we create a win-win situation for both customers and restaurants: customers get the meals they love at affordable prices, and restaurants retain more of their earnings to reinvest in their business.",
  future_every_meal_supports_local: "We’re creating a future where every meal supports a local restaurant, every order strengthens our community, and every experience is satisfying for all. We’re not just another food delivery service—we’re your partner in making dining accessible, affordable, and truly enjoyable.",
  
  get_started: "Get Started",
  get_started_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  register_your_restaurant_now: "Register Your Restaurant Now!",
  
  need_help: "Need Help?",
  need_help_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  email_us: "Email Us",
  call_us: "Call Us",

      how_do_i_place_an_order_on_loadinn: "How do I place an order on LOADINN?",
  to_place_an_order_log_in_select_restaurant_choose_items_checkout:
    "To place an order, log in to your account, select a restaurant, choose your food items, and proceed to checkout.",

  can_i_order_from_multiple_restaurants_at_the_same_time:
    "Can I order from multiple restaurants at the same time?",
  no_orders_must_be_placed_separately_for_each_restaurant:
    "No, orders must be placed separately for each restaurant.",

  can_i_schedule_an_order_for_later: "Can I schedule an order for later?",
  yes_you_can_schedule_an_order_for_a_later_time:
    "Yes, you can schedule an order for a later time.",

  what_payment_methods_are_accepted: "What payment methods are accepted?",
  we_accept_cards_apple_pay_google_pay_loadinn_wallet:
    "We accept credit/debit cards, Apple Pay, Google Pay, and the LOADINN Wallet.",

  are_there_any_hidden_charges: "Are there any hidden charges?",
  no_all_charges_are_displayed_before_confirming_the_order:
    "No, all applicable charges will be displayed before you confirm your order.",

  can_i_add_a_tip_for_the_delivery_driver:
    "Can I add a tip for the delivery driver?",
  yes_you_can_tip_the_driver_through_the_platform:
    "Yes, you can tip the driver through the platform.",

  how_can_i_track_my_order: "How can I track my order?",
  you_can_track_your_order_via_website_or_tracking_email:
    "You can track your order via our website or through the tracking email you receive after placing the order.",

  can_i_contact_the_delivery_driver: "Can I contact the delivery driver?",
  yes_you_can_contact_the_driver_if_needed:
    "Yes, you will have the option to contact the driver if needed.",

  what_if_my_delivery_is_delayed: "What if my delivery is delayed?",
  we_try_to_deliver_as_soon_as_possible_contact_support_if_issue:
    "We strive to deliver your order as soon as possible. If there is any issue, you can reach out to our support team via chat.",

  can_i_cancel_my_order_after_placing_it:
    "Can I cancel my order after placing it?",
  yes_but_cancellations_do_not_qualify_for_refund:
    "Yes, but cancellations do not qualify for a refund.",

  under_what_conditions_can_i_get_a_refund:
    "Under what conditions can I get a refund?",
  if_order_is_not_ready_after_one_hour_you_may_get_refund_contact_support_for_other_issues:
    "If your order is not ready even after one hour from the expected preparation time, you may be eligible for a refund. For other issues, please contact support.",

  how_long_does_refund_take: "How long does it take for a refund to process?",
  once_refund_is_approved_amount_is_credited_to_loadinn_wallet:
    "Once a refund is approved, the amount will be credited directly to your LOADINN Wallet.",

  do_i_need_an_account_to_place_an_order:
    "Do I need an account to place an order?",
  yes_you_must_create_an_account_to_place_an_order:
    "Yes, you must create an account to place an order.",

  what_if_i_forget_my_password: "What if I forget my password?",
  you_can_reset_your_password_anytime_even_if_forgotten:
    "You can reset your password anytime, even if you forget it.",

  how_can_i_contact_customer_support: "How can I contact customer support?",
  you_can_contact_us_via_chat_support_on_our_website:
    "You can reach us via chat support on our website.",
      home: "Home",
      add_restaurant: "Add Restaurant",
      delivery_partner: "Delivery Partner",
      account: "Account",
      contact_us: "Contact Us",
      login_signup: "Login/SignUp",
      satisfy_your_hunger_with:"Satisfy Your Hunger with",
      just_a_tap:"Just a Tap!",
      indulge_in_your_favorite_dishes_with_loadinn_where_every_delivery_feels_like_a_culinary_adventure:"Indulge in your favorite dishes with Loadinn—where every delivery feels like a culinary adventure!",
      search_for_restaurant_food_etc:"Search for restaurant, food etc",
      search:"Search",
      fast_and_reliable_delivery: "Fast and Reliable Delivery",
      enjoy_quick_dependable_deliveries_with_realtime_tracking_to_keep_you_in_the_loop: "Enjoy quick, dependable deliveries with real-time tracking to keep you in the loop.",
      easy_to_order: "Easy To Order",
      explore_a_wide_variety_of_restaurants_and_cuisines_to_suit_every_taste_and_craving: "Explore a wide variety of restaurants and cuisines to suit every taste and craving.",
      best_quality: "Best Quality",
      savor_every_bite_with_confidence_knowing_our_meals_are_crafted_from_the_freshest_highest_quality_ingredients: "Savor every bite with confidence, knowing our meals are crafted from the freshest, highest-quality ingredients",
      customer_support: "24/7 Customer Support",
      experience_top_notch_support_and_service_ensuring_your_satisfaction_with_every_order: "Experience top-notch support and service, ensuring your satisfaction with every order.",
      food_delivery_restaurants_in: "Food Delivery Restaurants in",
      riga: "Riga",
      view_all:"View All",
      where_every_meal_is_a: "Where Every Meal is a",
      delivery_delight: "Delivery Delight",
      at_loadinn: "At Loadinn, we turn meal times into moments of joy. Our goal is to deliver not just food, but a delightful experience every time. With a commitment to quick delivery and top-quality meals, we make sure your cravings are satisfied with a smile. Dive into a world where every delivery is a treat and every bite is a pleasure.",
      elevate_your_day_with_every_bite: "Elevate your day with every bite—because great food has the power to inspire and energize. At Loadinn, we believe every meal is a step towards a better you",
      order_now:"Order Now",
      why_restaurants:"Why Restaurants",
      love_working_with_us:"Love Working with Us",
      testimonials:"Testimonials",
      customizable:"Customizable",
      solutions_for_partners:"Solutions for Partners",
      unlock_new_revenue_streams_and_reach_a_wider_customer_base_by_partnering_with_us:"Unlock new revenue streams and reach a wider customer base by partnering with us. Our platform connects you with thousands of hungry customers ready to savor your delicious dishes.",
      frequently_asked:"Frequently Asked",
      questions:"Questions",
      get_the_latest:"Get the Latest",
      news_and_offers:"News & Offers",
      subscribe_to_our_newsletter_and_be_the_first_to_know_about_new_features_promotions_and_important_announcements:"Subscribe to our newsletter and be the first to know about new features, promotions, and important announcements. Stay ahead with our latest updates!",
      enter_your_email_here:"Enter your email here",
      subscribe:"Subscribe",
      about_loadInn:"About LoadInn",
      who_we_are:"Who We Are",
      why_choose_us:"Why Choose Us",
      contact_us:"Contact Us",
      earning:"Earning",
      become_restaurant_partner:"Become Restaurant Partner",
      become_delivery_partner:"Become Delivery Partner",
      terms_and_conditions:"Terms & Conditions",
      privacy_policy:"Privacy Policy",
      terms:"Terms",
      sitemap:"Sitemap",
      stay_connected_with_us:"Stay Connected with Us",
      get_the_latest_updates_by_following_us_online:"Get the latest updates by following us online!",
      copyright_all_right_reserved_created_by:"Copyright All Right Reserved 2025",
      add_your_restaurant_to_loadInn:"Add Your Restaurant to LoadInn",
      join_our_network_and_reach_more_customers_today:"Join our network and reach more customers today!",
      get_started:"Get Started",
      how_it_works:"How It Works",
      benefits: [
        {
          title: "Increase Your Reach",
          description:
            "Expand your customer base and reach more foodies in your area.",
          image: "img1",
        },
        {
          title: "Boost Your Visibility",
          description:
            "Get noticed by hungry customers looking for delicious meals.",
          image: "img2",
        },
        {
          title: "Grow Your Business",
          description:
            "Increase your revenue and grow your business with every order.",
          image: "img3",
        },
      ],
      launch_your: "Launch Your",
      internet_ordering_business:"Internet Ordering Business",
      please_make_sure_the_paperwork_is_ready_for_a_seamless_signup:"Please make sure the paperwork is ready for a seamless signup.",
      pvd_number: "PVD Number",
      vat_number: "VAT Number",
      enter_your_vat_number_here: "Enter your VAT number here",
      company_details: "Company Details",
      your_restaurant_menu: "Your Restaurant Menu",
      bank_account_details: "Bank Account Details",
      representative_details: "Representative Details",
      get: "Get",
      started: "Started!",
      register_your_restaurant_now: "Register Your Restaurant Now", 
      how_do_i_become_a_restaurant_partner:"How do I become a restaurant partner?",
      you_can_become_a_restaurant_partner_by_signing_up_on_our_platform_attending_a_short_training_and_getting_started_right_away:"You can become a restaurant partner by signing up on our platform, attending a short training, and getting started right away.",
      what_kind_of_marketing_support_do_you_provide_to_partner_restaurants:"What kind of marketing support do you provide to partner restaurants?",
      we_offer_various_marketing_tools_including_in_app_promotions_social_media_marketing_and_more_to_boost_your_restaurant_visibility:"We offer various marketing tools including in-app promotions, social media marketing, and more to boost your restaurant's visibility.",
      what_are_the_earnings_and_payment_methods_for_delivery_partners:"What are the earnings and payment methods for delivery partners?",
      delivery_partners_earn_based_on_the_number_of_orders_they_deliver_payments_are_processed_weekly_to_your_bank_account:"Delivery partners earn based on the number of orders they deliver. Payments are processed weekly to your bank account.",
      
      
      become_a: "Become a",
      delivery_partner: "Delivery Partner",
      join_our_network_and_earn_money_with_every_delivery:"Join our network and earn money with every delivery!",
      delivery_partner_details: "Delivery Partner Details",
      name: "Name",
      enter_your_name_here: "Enter your name here",
      phone_number: "Phone Number",
      language: "Language",
      enter_your_language_here: "Enter your language here",
      live_photo_of_id: "Live Photo of ID (Front & Back)",
      email: "Email",
      enter_your_email_here: "Enter your email here",
      vehicle_type: "Vehicle Type",
      enter_your_vehicle_type_here: "Enter your vehicle type here",
      id_number: "ID Number",
      enter_your_id_number_here: "Enter your ID number here",
      live_photo_of_person: "Live Photo of Person",
      deliver_partner_terms:"LoadInn may disclose the information provided by you, including but not limited to the contact number and email address of the authorised persons, with third party service providers for provision of LoadInn services.",
      continue: "Continue",
      back: "Back",
      submit: "Submit",
      view_plan: "View Plan",

      restaurant_information: "Restaurant Information",
      restaurant_information_details: "Restaurant name, address, contact no., owner details, etc.",
      select_price_plans: "Select Price & Plans",
      select_price_plans_details: "Establishment & cuisine type, opening hours",
      
      company_details: "Company Details",
      pvd_number: "PVD Number",
      registration_number: "Registration Number*",
      company_name: "Company Name*",
      company_address: "Company Address*",
      restaurant_name: "Restaurant Name*",
      enter_your_pvd_number_here: "Enter your PVD number here",
      enter_your_registration_number_here: "Enter your registration number here",
      enter_your_company_name_here: "Enter your company name here",
      enter_your_company_address_here: "Enter your company address here",
      enter_your_restaurant_name_here: "Enter your restaurant name here",
      location_details: "Location Details",
      this_will_help_your_customers_and_delivery_riders_to_locate_your_store: "This will help your customers and delivery riders to locate your store.",
      please_place_the_pin_accurately_at_your_outlets_location_on_the_map: "Please place the pin accurately at your outlet’s location on the map.*",
      enter_your_location: "Enter your location",
      detect: "Detect",

      restaurant_owner_details: "Contact Person Details",
      id_number: "ID Number*",
      email:  "Email*",
      restaurant_owner_house_address : "Restaurant Owner House Address*",
      phone_number: "Phone Number*",

      enter_your_id_number_here: "Enter your ID number here",
      enter_your_email_here: "Enter your email here",
      enter_your_restaurant_owner_house_address_here: "Enter your restaurant owner house address here",
      enter_your_phone_number_here: "Enter your phone number here",

      




  a_partner_centric_approach_to_your_success: "A Partner-Centric Approach to Your Success",
  partner_centric_description: "We’re more than just a delivery service – we’re a partner invested in your growth. From day one, we make it our mission to understand your business and align our services with your goals. Our dedicated support team is always here to assist you, ensuring that any issues or requests are handled promptly so you can focus on what you do best – creating great food.",

  expanded_customer_reach: "Expanded Customer Reach",
  expanded_customer_reach_description: "By partnering with us, you’ll gain access to a vast network of loyal customers in your area, helping you increase orders and enhance your brand’s visibility without additional advertising costs.",

  simple_integration_intuitive_management_tools: "Simple Integration & Intuitive Management Tools",
  simple_integration_description: "Our platform offers easy integration and management tools that allow you to control orders, update your menu, and track your performance – all from a single, user-friendly dashboard.",

  couriers_who_care_about_your_food: "Couriers Who Care About Your Food",
  couriers_who_care_description: "Our reliable couriers are trained to handle your orders with the utmost care, ensuring your food arrives fresh and beautifully presented, making a positive impression on your customers.",

  data_driven_growth_insights: "Data-Driven Growth Insights",
  data_driven_growth_description: "We provide insights into order trends, customer feedback, and sales analytics to help you understand your market better and make informed decisions for continuous growth.",

  fair_and_transparent_partnership_terms: "Fair and Transparent Partnership Terms",
  fair_transparent_terms_description: "Our no-commission policy and transparent agreements ensure that you retain profitability, with no hidden fees. We succeed when you do, so we’re committed to offering terms that truly benefit our restaurant partners.",

  always_available_support_and_marketing_perks: "Always-Available Support and Marketing Perks",
  always_available_support_description: "With 24/7 support, you can count on us for prompt assistance. Plus, our in-house marketing helps boost your visibility with promotions and campaigns designed to attract more customers to your business."
,


      


      contact: "Contact",
      us: "Us",
      any_question_or_remarks_just_write_us_a_message: "Any question or remarks? Just write us a message!",
      contact_information: "Contact Information",
      say_something_to_start_a_live_chat: "Say something to start a live chat!",
        need: "Need",
  help: "help",
call_us: "Call Us",
email_ud: "Email Us",
account_setting: "Account Setting",
  profile: "Profile",
  order_history: "Order History",
  wallet: "Wallet",
  give_feedback: "Give Feedback",
  delete_account: "Delete Account",
  wallet_balance: "Wallet Balance",
  transaction_history: "Transaction History",
  date: "Date",
  description: "Description",
  amount: "Amount",
  status: "Status",
  
      sign_up: "Sign Up",
  sign_up_description: "Create your free LOADINN account in just a few clicks. Get instant access to tools designed to help your restaurant grow online.",

  list_your_restaurant: "List Your Restaurant",
  list_your_restaurant_description: "Add your menu, photos, prices, and details. Make your restaurant visible to thousands of hungry customers searching for their next meal.",

  start_receiving_orders: "Start Receiving Orders",
  start_receiving_orders_description: "Go live and start getting online orders directly through LOADINN. Manage everything from one dashboard with ease.",

  grow_with_loadinn: "Grow with LOADINN",
  grow_with_loadinn_description: "Track sales, increase visibility, and boost revenue. With our platform, your restaurant gets more customers and more opportunities to expand."

    


      
      

    },
      
  },
  lv: {
    translation: {
      why_to_choose_us: "Kāpēc izvēlēties mūs?",
  wide_variety_of_choices: "Plaša izvēle",
  we_believe_food_should_cater_to_everyone: "Mēs ticam, ka ēdiens jāpielāgo katra garšai un uztura prasībām, tāpēc piedāvājam plašu virtuves, garšu un maltīšu izvēli. Neatkarīgi no tā, vai vēlaties komforta ēdienu, veselīgu salātu vai kaut ko drosmīgu, mēs par jums parūpēsimies.",
  menu_includes_options_for_every_preference: "Mūsu ēdienkartē ir iespējas katram: vegāni, veģetārieši, bezglutēna izvēles, kā arī augstu proteīnu un zemu kaloriju ēdieni veselīgi domājošiem. Mēs arī mainām sezonas un īpašos ēdienus, lai uzturētu svaigumu un interesantumu.",
  curating_diverse_range_of_meals: "Izveidojot dažādu maltīšu klāstu un sadarbojoties ar talantīgiem šefpavāriem, mēs nodrošinām, ka vienmēr ir kaut kas jauns un garšīgs, ko izmēģināt. Vienmēr varat atrast perfektu maltīti neatkarīgi no jūsu vēlmēm vai uztura prasībām.",

  reliable_and_fast_delivery: "Uzticama un ātra piegāde",
  delivery_service_peak_condition: "Mūsu piegādes serviss nodrošina, ka jūsu ēdiens sasniedz jūs ideālā stāvoklī. Mēs zinām, cik svarīgs ir laiks, tāpēc izmantojam maršruta optimizāciju, lai mūsu piegādātāji izvēlētos ātrākos un efektīvākos ceļus līdz jums.",
  real_time_tracking: "Ar reāllaika izsekošanu jūs vienmēr zināt, kur atrodas jūsu pasūtījums, tāpēc varat plānot savu laiku bez pārsteigumiem. Mēs arī uzturam īsus piegādes laikus, lai jūsu ēdiens ierastos tikpat svaigs un garšīgs kā tikko no virtuves.",
  experienced_delivery_drivers: "Mūsu pieredzējušie piegādātāji ir veltīti augstas kvalitātes pakalpojumam, rūpējoties par katru pasūtījumu, lai jūs vienmēr saņemtu uzticamu pieredzi, izvēloties mūs.",

  user_friendly_technology: "Viegli lietojama tehnoloģija",
  smooth_and_convenient_ordering: "Mēs esam izstrādājuši pasūtīšanas platformu, lai jūsu ēdiena piegādes pieredze būtu pēc iespējas vienkāršāka un ērtāka. Neatkarīgi no tā, vai izmantojat mūsu lietotni vai vietni, jūs varat ērti pārlūkot ēdienkarti, pielāgot maltīti un veikt pasūtījumu dažos klikšķos.",
  real_time_tracking_and_secure_payments: "Reāllaika izsekošana ļauj jums sekot pasūtījuma statusam no virtuves līdz jūsu durvīm. Ar vairākām drošām maksājumu iespējām norēķini ir ātri un vienkārši. Baudiet ērtības savās rokās, pielāgotas jūsu dzīves ritmam.",

  affordable_pricing_and_promotions: "Pieejamas cenas un akcijas",
  customers_at_heart: "Mūsu klienti ir vissvarīgākie. Mēs esam apņēmušies nodrošināt jūsu apmierinātību ar katru pasūtījumu, un mūsu klientu apkalpošanas komanda ir šeit, lai jūs atbalstītu sākot no pasūtīšanas līdz piegādei.",
  listen_to_feedback: "Mēs uzklausām jūsu atsauksmes un tās ņemam vērā, pastāvīgi uzlabojot mūsu pakalpojumu. Ar ātru reakciju un draudzīgu, palīdzīgu servisu mēs nodrošinām, ka jūsu pieredze ar mums ir izcila.",
  go_above_and_beyond: "Mūsu komanda ir apmācīta pārsniegt gaidīto, rūpīgi un profesionāli apstrādājot katru pieprasījumu. Izvēloties mūs, jūs izvēlaties pakalpojumu, kas novērtē jūsu pieredzi un padara katru maltīti īpašu.",

  couriers: "Kurjeri",
  competitive_earnings: "Konkurētspējīga alga",
  earnings_text: "Mēs ticam, ka jūsu smagais darbs jāpārvērš reālās finansiālās atlīdzībās. Mūsu likmes ir vienas no augstākajām nozarē. Ar mums katra piegāde patiešām ir vērtīga.",
  flexible_scheduling: "Elastīgs grafiks",
  flexible_scheduling_text: "Elastīgums ir viens no galvenajiem iemesliem, kāpēc cilvēki izvēlas būt kurjeri, un mēs to cienām. Neatkarīgi no tā, vai strādājat pilnu slodzi, nepilnu slodzi, brīvdienās vai dažas stundas dienā, jūs kontrolējat savu grafiku. Mūsu lietotne ļauj vienkārši tiešsaistē sākt darbu un bezsaistē beigt to.",
  support_and_resources: "24/7 atbalsts un resursi",
  support_and_resources_text: "Mēs zinām, ka kurjeri dažkārt saskaras ar neparedzētām problēmām. Mūsu atbalsta komanda ir pieejama visu diennakti, palīdzot ar maršruta izmaiņām, lietotnes atbalstu un apmācības resursiem drošības, klientu apkalpošanas un efektivitātes jautājumos.",
  reliable_and_transparent_payments: "Uzticami un caurspīdīgi maksājumi",
  reliable_and_transparent_payments_text: "Ar LoadInn jūs varat būt droši, ka jūsu pelnītie līdzekļi tiks saņemti laikā, katru reizi. Mūsu caurspīdīgā maksājumu sistēma parāda tieši, ko pelnāt par katru piegādi, bez slēptām maksām. Maksājumi tiek veikti nedēļas laikā vai ātrāk ar tūlītēju maksājumu opciju.",
  local_delivery_focus: "Fokusēšanās uz vietējo piegādi",
  local_delivery_focus_text: "Mēs prioritizējam jūsu apkārtnes pasūtījumus, tādējādi jūs strādājat tuvāk mājām un samazināt ceļa un degvielas izmaksas. Pazīstamas apkārtnes nozīmē ātrākas piegādes un efektīvākus maršrutus, palīdzot pabeigt vairāk pasūtījumu īsākā laikā.",

  restaurant: "Restorāns",
  get_started: "Sāciet!",
  get_started_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  register_your_restaurant_now: "Reģistrējiet savu restorānu tagad!",
  need_help: "Nepieciešama palīdzība?",
  need_help_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  email_us: "Rakstiet mums",
  call_us: "Zvaniet mums"
,
  a_partner_centric_approach_to_your_success: "Partnera orientēta pieeja jūsu panākumiem",
  partner_centric_description: "Mēs esam vairāk nekā tikai piegādes serviss – mēs esam partneris, kurš rūpējas par jūsu izaugsmi. No pirmās dienas mūsu misija ir saprast jūsu biznesu un pielāgot pakalpojumus jūsu mērķiem. Mūsu atbalsta komanda vienmēr ir gatava palīdzēt, lai jūs varētu koncentrēties uz to, kas jums padodas vislabāk – izcilu ēdienu gatavošanu.",
  
  expanded_customer_reach: "Paplašināta klientu sasniedzamība",
  expanded_customer_reach_description: "Sadarbojoties ar mums, jūs iegūstat piekļuvi plašam lojālu klientu tīklam jūsu reģionā, palielinot pasūtījumu skaitu un uzlabojot zīmola redzamību bez papildu reklāmas izmaksām.",
  
  simple_integration_intuitive_management_tools: "Vienkārša integrācija un intuitīvi pārvaldības rīki",
  simple_integration_description: "Mūsu platforma piedāvā vieglu integrāciju un pārvaldības rīkus, kas ļauj kontrolēt pasūtījumus, atjaunināt ēdienkarti un sekot līdzi veiktspējai – viss no viena lietotājam draudzīga informācijas paneļa.",
  
  couriers_who_care_about_your_food: "Kurjeri, kuri rūpējas par jūsu ēdienu",
  couriers_who_care_description: "Mūsu uzticamie kurjeri apmācīti rūpīgi apstrādāt jūsu pasūtījumus, nodrošinot, ka ēdiens tiek piegādāts svaigs un estētiski pasniegts, radot pozitīvu iespaidu uz jūsu klientiem.",
  
  data_driven_growth_insights: "Datu analīze izaugsmes veicināšanai",
  data_driven_growth_description: "Mēs sniedzam ieskatus par pasūtījumu tendencēm, klientu atsauksmēm un pārdošanas analīzi, lai labāk izprastu tirgu un pieņemtu pamatotus lēmumus turpmākai izaugsmei.",
  
  fair_and_transparent_partnership_terms: "Godīgi un caurspīdīgi sadarbības noteikumi",
  fair_transparent_terms_description: "Mūsu politika bez komisijas maksas un caurspīdīgi līgumi nodrošina, ka saglabājat rentabilitāti bez slēptām maksām. Mēs gūstam panākumus tikai tad, kad gūstat jūs.",
  
  always_available_support_and_marketing_perks: "Pastāvīgs atbalsts un mārketinga priekšrocības",
  always_available_support_description: "Ar 24/7 atbalstu jūs varat paļauties uz mūsu palīdzību. Turklāt mūsu iekšējais mārketings veicina redzamību ar akcijām un kampaņām, lai piesaistītu vairāk klientu jūsu biznesam."
,
       about_us: "Par mums",
  who_we_are: "Kas mēs esam",
  question_mark: "?",
  who_we_are_alt: "Kas mēs esam attēls",
  we_believe_food_is_more_than_meal: "LoadInn uzskata, ka ēdiens ir vairāk nekā tikai maltīte — tas ir veids, kā apvienot cilvēkus, radīt pieredzi un svinēt kopienu. Mūsu platforma ir izstrādāta, lai saīsinātu ceļu starp klientiem un vietējiem restorāniem, sniedzot pakalpojumu, kas abām pusēm sniedz nozīmīgu labumu. Mēs esam apņēmušies radīt vienmērīgu, pieejamu un apmierinošu pieredzi visiem iesaistītajiem.",
  
  for_our_customers: "Mūsu klientiem",
  customers_seek_quality_transparency: "Mēs saprotam, ka mūsdienu klienti meklē ne tikai ērtības; viņi vēlas kvalitatīvu ēdienu, caurspīdīgumu un pieejamas cenas.",
  customers_section1_img_alt: "Mēs esam izstrādājuši platformu ar jums prātā",
  customers_section1_text: "LoadInn ir izveidojusi platformu ar jums prātā. Piedāvājot plašu vietējo restorānu izvēli, mēs dodam iespēju izpētīt un pasūtīt savus iecienītākos ēdienus vienuviet. Mēs arī esam apņēmušies uzturēt godīgas cenas.",
  customers_section2_img_alt: "Bez slēptām komisijas maksām",
  customers_section2_text: "Tā kā mēs neiekasējam augstas komisijas maksas restorāniem, viņi var nodot šīs ietaupījumu uz jums. Tas nozīmē, ka jūs saņemat lielisku ēdienu par pieejamām cenām — bez slēptām maksām. LoadInn nodrošina, ka katra jūsu pasūtītā maltīte ir garšīga un vērtīga.",
  
  for: "Par",
  our_partner_restaurants: "Mūsu partnerrestorāniem",
  partner_restaurants_img_alt: "Partnerrestorānu attēls",
  restaurants_heart_of_community: "Mēs zinām, ka restorāni ir jebkuras kopienas sirds, un mēs esam šeit, lai palīdzētu jums attīstīties bez augstu komisijas maksu sloga.",
  subscription_model_advantages: "Atšķirībā no tradicionālajām pārtikas piegādes platformām, LoadInn neiekasē komisijas maksu restorāniem. Tā vietā mēs piedāvājam vienkāršu abonēšanas modeli, kas ļauj jums kontrolēt izmaksas, palielināt redzamību un apkalpot vairāk klientu — saglabājot vairāk jūsu nopelnītā ienākuma.",
  financial_flexibility_for_restaurants: "Šī pieeja palīdz jums ilgtspējīgi attīstīt biznesu un piedāvā lielāku finanšu elastību. Mēs palīdzam jums sasniegt vairāk ēdienu pasūtītāju, optimizēt darbību un turpināt piedāvāt izcilu ēdināšanas pieredzi, kas padara jūsu restorānu unikālu.",
  
  building_fairer_stronger_community: "Veidojam taisnīgāku un spēcīgāku kopienu",
  loadinn_more_than_platform: "LoadInn ir vairāk nekā tikai platforma; tas ir kustība, lai padarītu pārtikas piegādes pieredzi labāku visiem. Neiekasējot komisijas maksas, mēs radām abpusēji izdevīgu situāciju gan klientiem, gan restorāniem: klienti saņem iecienītākās maltītes par pieejamām cenām, un restorāni saglabā vairāk savas peļņas, lai to ieguldītu biznesā.",
  future_every_meal_supports_local: "Mēs veidojam nākotni, kur katra maltīte atbalsta vietējo restorānu, katrs pasūtījums stiprina mūsu kopienu, un katra pieredze sniedz gandarījumu visiem. Mēs neesam tikai vēl viena pārtikas piegādes platforma — mēs esam jūsu partneris, padarot ēdināšanu pieejamu, pieņemamu un patiesi patīkamu.",
  
  get_started: "Sāciet jau tagad",
  get_started_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  register_your_restaurant_now: "Reģistrējiet savu restorānu tūlīt!",
  
  need_help: "Nepieciešama palīdzība?",
  need_help_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  email_us: "Sūtīt e-pastu",
  call_us: "Zvanīt mums",
        how_do_i_place_an_order_on_loadinn: "Kā es varu veikt pasūtījumu LOADINN?",
  to_place_an_order_log_in_select_restaurant_choose_items_checkout:
    "Lai veiktu pasūtījumu, piesakieties savā kontā, izvēlieties restorānu, atlasiet ēdienus un pārejiet uz apmaksu.",

  can_i_order_from_multiple_restaurants_at_the_same_time:
    "Vai varu pasūtīt no vairākiem restorāniem vienlaicīgi?",
  no_orders_must_be_placed_separately_for_each_restaurant:
    "Nē, pasūtījumi jāveic atsevišķi katram restorānam.",

  can_i_schedule_an_order_for_later:
    "Vai varu ieplānot pasūtījumu uz vēlāku laiku?",
  yes_you_can_schedule_an_order_for_a_later_time:
    "Jā, jūs varat ieplānot pasūtījumu uz vēlāku laiku.",

  what_payment_methods_are_accepted: "Kādus maksājumu veidus pieņemat?",
  we_accept_cards_apple_pay_google_pay_loadinn_wallet:
    "Mēs pieņemam kredītkartes/debetkartes, Apple Pay, Google Pay un LOADINN maku.",

  are_there_any_hidden_charges: "Vai ir kādi slēpti maksājumi?",
  no_all_charges_are_displayed_before_confirming_the_order:
    "Nē, visi maksājumi tiek parādīti pirms pasūtījuma apstiprināšanas.",

  can_i_add_a_tip_for_the_delivery_driver:
    "Vai varu pievienot dzeramnaudu kurjeram?",
  yes_you_can_tip_the_driver_through_the_platform:
    "Jā, jūs varat pievienot dzeramnaudu kurjeram platformā.",

  how_can_i_track_my_order: "Kā varu izsekot savam pasūtījumam?",
  you_can_track_your_order_via_website_or_tracking_email:
    "Jūs varat izsekot savam pasūtījumam mūsu mājaslapā vai caur e-pasta izsekošanas ziņojumu.",

  can_i_contact_the_delivery_driver: "Vai varu sazināties ar kurjeru?",
  yes_you_can_contact_the_driver_if_needed:
    "Jā, nepieciešamības gadījumā jūs varēsiet sazināties ar kurjeru.",

  what_if_my_delivery_is_delayed: "Kas notiek, ja piegāde kavējas?",
  we_try_to_deliver_as_soon_as_possible_contact_support_if_issue:
    "Mēs cenšamies piegādāt pēc iespējas ātrāk. Ja ir problēmas, sazinieties ar mūsu atbalstu čatā.",

  can_i_cancel_my_order_after_placing_it:
    "Vai varu atcelt pasūtījumu pēc tā veikšanas?",
  yes_but_cancellations_do_not_qualify_for_refund:
    "Jā, taču atcelšana neparedz naudas atmaksu.",

  under_what_conditions_can_i_get_a_refund:
    "Kādos gadījumos varu saņemt atmaksu?",
  if_order_is_not_ready_after_one_hour_you_may_get_refund_contact_support_for_other_issues:
    "Ja pasūtījums nav gatavs pat stundu pēc paredzētā laika, jūs varat saņemt atmaksu. Citiem gadījumiem, lūdzu, sazinieties ar atbalstu.",

  how_long_does_refund_take: "Cik ilgi notiek naudas atmaksa?",
  once_refund_is_approved_amount_is_credited_to_loadinn_wallet:
    "Pēc atmaksas apstiprināšanas summa tiks ieskaitīta jūsu LOADINN makā.",

  do_i_need_an_account_to_place_an_order:
    "Vai nepieciešams konts, lai veiktu pasūtījumu?",
  yes_you_must_create_an_account_to_place_an_order:
    "Jā, jums ir jāizveido konts, lai veiktu pasūtījumu.",

  what_if_i_forget_my_password: "Kas notiek, ja aizmirstu paroli?",
  you_can_reset_your_password_anytime_even_if_forgotten:
    "Jūs varat jebkurā laikā atjaunot savu paroli, pat ja to esat aizmirsis.",

  how_can_i_contact_customer_support: "Kā varu sazināties ar klientu atbalstu?",
  you_can_contact_us_via_chat_support_on_our_website:
    "Jūs varat sazināties ar mums, izmantojot čata atbalstu mūsu mājaslapā."
,
      home: "Sākums",
      add_restaurant: "Pievienot restorānu",
      delivery_partner: "Piegādes partneris",
      account: "Konts",
      contact_us: "Sazinies ar mums",
      login_signup: "Pieslēgties / Reģistrēties",
      satisfy_your_hunger_with:"Apmieriniet savu izsalkumu ar",
      just_a_tap:"Vienkārši pieskarieties!",
      search_for_restaurant_food_etc:"Meklēt restorānu, ēdienu utt",
      search:"Meklēt",
      fast_and_reliable_delivery:"Ātra un uzticama piegāde",
      enjoy_quick_dependable_deliveries_with_realtime_tracking_to_keep_you_in_the_loop:"Izbaudiet ātras, uzticamas piegādes ar reāllaika izsekošanu, lai jūs būtu informēti.",
      easy_to_order: "Viegli pasūtīt",
      explore_a_wide_variety_of_restaurants_and_cuisines_to_suit_every_taste_and_craving: "Izpētiet plašu restorānu un virtuves veidu klāstu, lai atbilstu katram garšas un kāršu vēlmēm." ,
      best_quality: "Labākā kvalitāte",
      savor_every_bite_with_confidence_knowing_our_meals_are_crafted_from_the_freshest_highest_quality_ingredients: "Izbaudiet katru kārumu ar pārliecību, zinot, ka mūsu ēdieni ir gatavoti no svaigākajiem, augstākās kvalitātes sastāvdaļām",
      customer_support: "24/7 klientu atbalsts",
      experience_top_notch_support_and_service_ensuring_your_satisfaction_with_every_order: "Iepazīstieties ar pirmšķirīgu atbalstu un apkalpošanu, nodrošinot jūsu apmierinātību ar katru pasūtījumu.",
      food_delivery_restaurants_in: "Ēdienu piegādes restorāni",
      riga: "Rīgā",
      view_all:"Skatīt visu",
      where_every_meal_is_a: "Kur katrs ēdiens ir",
      delivery_delight: "Piegādes prieks",
      at_loadinn: "Loadinnā mēs pārvēršam ēdienreizes prieka brīžos. Mūsu mērķis ir nodrošināt ne tikai ēdienu, bet katru reizi patīkamu pieredzi. Ar apņemšanos nodrošināt ātru piegādi un augstas kvalitātes ēdienus, mēs nodrošinām, ka jūsu kāršu tiek apmierinātas ar smaidu. Iegrimiet pasaulē, kur katra piegāde ir pārsteigums un katrs kārums ir prieks.",   
      elevate_your_day_with_every_bite: "Paaugstiniet savu dienu ar katru kārumu, jo lieliskam ēdienam ir spēks iedvesmot un enerģēt. Loadinnā mēs uzskatām, ka katrs ēdiens ir solis uz labāku jums",
      order_now: "Pasūtīt tagad",
      why_restaurants:"Kāpēc restorāni",
      love_working_with_us:"mīl strādāt ar mums",
      testimonials:"Atsauksmes",
      customizable: "Pielāgojams",
      solutions_for_partners:"Risinājumi partneriem",
      unlock_new_revenue_streams_and_reach_a_wider_customer_base_by_partnering_with_us:"Atbloķējiet jaunus ieņēmumu straumus un sasniedziet plašāku klientu bāzi, sadarbojoties ar mums. Mūsu platforma savieno jūs ar tūkstošiem izsalkušu klientu, gatavu baudīt jūsu garšīgos ēdienus.",
      frequently_asked:"Bieži uzdotie",
      questions:"Jautājumi",
      get_the_latest:"Saņemiet jaunākās",
      news_and_offers:"Ziņas un piedāvājumi",
      subscribe_to_our_newsletter_and_be_the_first_to_know_about_new_features_promotions_and_important_announcements:"Abonējiet mūsu jaunumus un būsiet pirmie, kas uzzinās par jaunām funkcijām, akcijām un svarīgiem paziņojumiem. Palieciet soli priekšā ar mūsu jaunākajiem atjauninājumiem!",
      enter_your_email_here: "Ievadiet savu e-pastu šeit",
      subscribe: "Abonēt",
      about_loadInn:"Par LoadInn",
      who_we_are:"Kas mēs esam",
      why_choose_us:"Kāpēc izvēlēties mūs",
      contact_us:"Sazinies ar mums",
      earning:"Ienākumi",
      become_restaurant_partner:"Kļūstiet par restorāna partneri",
      become_delivery_partner:"Kļūstiet par piegādes partneri",
      terms_and_conditions:"Noteikumi un nosacījumi",
      privacy_policy:"Konfidencialitātes politika",
      terms: "Noteikumi",
      sitemap: "Vietnes karte",
      stay_connected_with_us:"Palieciet saistīti ar mums",
      get_the_latest_updates_by_following_us_online:"Saņemiet jaunākās atjauninājumus, sekojot mums tiešsaistē!",
      copyright_all_right_reserved_created_by:"Autortiesības Visas tiesības aizsargātas 2025",
      add_your_restaurant_to_loadInn: "Pievienojiet savu restorānu LoadInn",
      join_our_network_and_reach_more_customers_today: "Pievienojieties mūsu tīklam un sasniedziet vairāk klientu jau šodien!",
      get_started: "Sākt",
      how_it_works: "Kā tas darbojas",
      benefits: [],
      launch_your: "Uzsāciet savu",
      internet_ordering_business: "Interneta pasūtījumu biznesu",
      please_make_sure_the_paperwork_is_ready_for_a_seamless_signup: "Lūdzu, pārliecinieties, ka dokumentācija ir gatava vienmērīgai reģistrācijai.",
      pvd_number: "PVD numurs",
      vat_number: "PVN numurs",
      enter_your_vat_number_here: "Ievadiet savu PVN numuru šeit",
      company_details: "Uzņēmuma detaļas",
      your_restaurant_menu: "Jūsu restorāna ēdienkarte",
      bank_account_details: "Bankas konta detaļas",
      representative_details: "Priekšstāvja detaļas",
      get: "Saņemt",
      started: "Sākt",
      register_your_restaurant_now: "Reģistrējiet savu restorānu tagad",
      how_do_i_become_a_restaurant_partner: "Kā es varu kļūt par restorāna partneri?",
      you_can_become_a_restaurant_partner_by_signing_up_on_our_platform_attending_a_short_training_and_getting_started_right_away: "Jūs varat kļūt par restorāna partneri, reģistrējoties mūsu platformā, apmeklējot īsu apmācību un uzsākot darbu nekavējoties.",
      what_kind_of_marketing_support_do_you_provide_to_partner_restaurants: "Kādu mārketinga atbalstu jūs sniedzat partneru restorāniem?",
      we_offer_various_marketing_tools_including_in_app_promotions_social_media_marketing_and_more_to_boost_your_restaurant_visibility: "Mēs piedāvājam dažādus mārketinga rīkus, tostarp iekšējās lietotnes reklāmas, sociālo mediju mārketingu un daudz ko citu, lai palielinātu jūsu restorāna redzamību.",
      what_are_the_earnings_and_payment_methods_for_delivery_partners: "Kādi ir piegādes partneru ienākumi un maksājumu metodes?",
      delivery_partners_earn_based_on_the_number_of_orders_they_deliver_payments_are_processed_weekly_to_your_bank_account: "Piegādes partneri pelna atkarībā no piegādāto pasūtījumu skaita. Maksājumi tiek apstrādāti reizi nedēļā uz jūsu bankas kontu.",
      
      
      become_a: "Kļūstiet par",
      delivery_partner: "Piegādes partneri",
      join_our_network_and_earn_money_with_every_delivery: "Pievienojieties mūsu tīklam un pelniet naudu ar katru piegādi!",
      delivery_partner_details: "Piegādes partnera dati",
      name: "Vārds",
      enter_your_name_here: "Ievadiet savu vārdu šeit",
      phone_number: "Telefona numurs",
      language: "Valoda",
      enter_your_language_here: "Ievadiet savu valodu šeit",
      live_photo_of_id: "Dzīva ID foto (priekšējā un aizmugurējā daļā)",
      email: "E-pasts",
      enter_your_email_here: "Ievadiet savu e-pastu šeit",
      vehicle_type: "Transportlīdzekļa tips",
      enter_your_vehicle_type_here: "Ievadiet savu transportlīdzekļa tipu šeit",
      id_number: "ID numurs",
      enter_your_id_number_here: "Ievadiet savu ID numuru šeit",
      live_photo_of_person: "Dzīva personas foto",
      deliver_partner_terms: "LoadInn var atklāt jūsu sniegto informāciju, ieskaitot, bet ne tikai, pilnvaroto personu kontaktinformāciju un e-pasta adresi, trešajiem pakalpojumu sniedzējiem, lai sniegtu LoadInn pakalpojumus.",
      continue: "Turpināt",
      back: "Atpakaļ",
      submit: "Iesniegt",
      view_plan: "Skatīt plānu",

      

      restaurant_information: "Restorāna informācija",
      restaurant_information_details: "Restorāna nosaukums, adrese, kontaktinformācija, īpašnieka dati utt.",
      select_price_plans: "Izvēlieties cenas un plānus",
      select_price_plans_details: "Iestādes un virtuves tips, darba laiks",
      company_details: "Uzņēmuma detaļas",

      pvd_number: "PVD numurs*",
      registration_number: "Reģistrācijas numurs*",
      company_name: "Uzņēmuma nosaukums*",
      company_address: "Uzņēmuma adrese*",
      restaurant_name: "Restorāna nosaukums*",
      enter_your_pvd_number_here: "Šeit ievadiet savu PVD numuru",
      enter_your_registration_number_here: "Šeit ievadiet savu reģistrācijas numuru",
      enter_your_company_name_here: "Šeit ievadiet sava uzņēmuma nosaukumu",
      enter_your_company_address_here: "Šeit ievadiet sava uzņēmuma adresi",
      enter_your_restaurant_name_here: "Šeit ievadiet sava restorāna nosaukumu",
      location_details: "Atrašanās vietas detaļas",
      this_will_help_your_customers_and_delivery_riders_to_locate_your_store: "Šī palīdzēs jūsu klientiem un piegādes braucējiem atrast jūsu veikalu.",
      please_place_the_pin_accurately_at_your_outlets_location_on_the_map: "Lūdzu, precīzi novietojiet adatu uz jūsu veikala atrašanās vietas kartē.*",
      enter_your_location: "Ievadiet savu atrašanās vietu",
      detect: "Atklāt",

      

      contact: "Sazināties",
      us: "Ar mums",
      any_question_or_remarks_just_write_us_a_message: "Jebkuri jautājumi vai piezīmes, vienkārši rakstiet mums ziņu",
      contact_information: "Kontaktinformācija",
      say_something_to_start_a_live_chat: "Sakiet kaut ko, lai uzsāktu tiešraides tērzēšanu!",
      need: "Nepieciešama",
  help: "palīdzība",
  call_us: "Zvaniet mums",
email_ud: "Sūtiet mums e-pastu",
account_setting: "Kontu iestatījumi",
  profile: "Profils",
  order_history: "Pasūtījumu vēsture",
  wallet: "Maciņš",
  give_feedback: "Sniedziet atsauksmes",
  delete_account: "Dzēst kontu",
  wallet_balance: "Maciņa bilance",
  transaction_history: "Transakciju vēsture",
  date: "Datums",
  description: "Apraksts",
  amount: "summa",
  status: 'statusu',
  search_food_here: "Meklēt ēdienu šeit",
  order_online: "Pasūtīt tiešsaistē",
  cart_detail: "Groza detaļas",
  subtotal: "Starpsumma",
  choose_delivery_option:"Izvēlieties piegādes iespēju",
  pickup: "Pikaps",
  delivery: "Piegāde",
  enter_coupon_code: "Ievadiet kupona kodu",
  apply: "Piesakies",
  delivery_charge: "Piegādes maksa",
  total: "Kopā",
  use_wallet_balance: "Izmantojiet makiņa bilanci",
  type_your_description_here: "Ievadiet savu aprakstu šeit",
  place_order: "Veikt pasūtījumu",
  add_to_cart: "Pievienot grozam",
  delivery_address: "Piegādes adrese",
  select_an_address: "Izvēlieties adresi",
  select_address: "Izvēlieties adresi",
  add_new_address: "Pievienot jaunu adresi",
  address: "Adrese",
  enter_address_here: "Ievadiet adresi šeit",
  entrance: "Ieeja",
  floor: "Stāvs",
  apartment_office: "Dzīvoklis/Ofiss",
  instuctions_for_courier: "Instrukcijas kurjeram",
  enter_entrance_here: "Ievadiet ieeju šeit",
  enter_floor_here: "Ievadiet stāvu šeit",
  enter_apartment_office_here: "Ievadiet dzīvokli/ofisu šeit",
  enter_instructions_here: "Ievadiet instrukcijas šeit",
  save_address: "Saglabāt adresi",
  cancel: "Atcelt",
  review: "Atsauksmes",
  closed_for_today: "Šodien slēgts",
  welcome: "",
  please_sign_in_to_continue_and_make_the_most_of_our_platform: "",
  enter_your_email_id: "",
  password: "",
  enter_your_password: "",
  password_is_requiored:"",
  email_is_required:"",
  login:"",
  dont_have_account: "",
  create_new_account:"",
  get_started: "",
  join_us_today: "Join us today and experience the best in food delivery services.",
  full_name: "Full Name",
  enter_your_full_name_here: "Enter your full name here",
  already_have_account: "Already have an account?",
  i_agree_to_the: "I agree to the",
  terms_of_service: "Terms of Service",
  and: "and",
  privacy_policy: "Privacy Policy", 
  create_account: "Create Account",
  already_have_account: "Already have an account?",
  login_here: "Sign In here",





  sign_up: "Reģistrēties",
  sign_up_description: "Izveidojiet savu bezmaksas LOADINN kontu tikai dažu klikšķu laikā. Iegūstiet tūlītēju piekļuvi rīkiem, kas izstrādāti, lai palīdzētu jūsu restorānam augt tiešsaistē.",

  list_your_restaurant: "Pievienojiet savu restorānu",
  list_your_restaurant_description: "Pievienojiet savu ēdienkarti, fotoattēlus, cenas un detaļas. Padariet savu restorānu redzamu tūkstošiem izsalkušu klientu, kas meklē nākamo maltīti.",

  start_receiving_orders: "Sāciet saņemt pasūtījumus",
  start_receiving_orders_description: "Darbojieties tiešsaistē un sāciet saņemt tiešos pasūtījumus caur LOADINN. Viegli pārvaldiet visu no viena informācijas paneļa.",

  grow_with_loadinn: "Augiet ar LOADINN",
  grow_with_loadinn_description: "Izsekojiet pārdošanu, palieliniet redzamību un palieliniet ieņēmumus. Ar mūsu platformu jūsu restorāns iegūst vairāk klientu un vairāk iespēju paplašināties."


    },
     

   
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // Default language
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
